import $ from "jquery";

$.fn.epAddTabbableInsidePopup = function () {
    var _this = this;

    this.off("keydown.tabbableinsidepopup").on("keydown.tabbableinsidepopup", function (event) {
        // prevent tabbing out of dialogs
        if (event.keyCode !== 9) {
            return;
        }

        var tabbables = _this.find(":tabbable"),
            first = tabbables.filter(":first"),
            last = tabbables.filter(":last");

        if ((event.target === last[0] || event.target === _this) && !event.shiftKey) {
            first.focus();
            event.preventDefault();
        } else if ((event.target === first[0] || event.target === _this) && event.shiftKey) {
            last.focus();
            event.preventDefault();
        }
    });
};
